import bingo_ball_1 from './public/images/bingo_ball_1.png';
import bingo_ball_2 from './public/images/bingo_ball_2.png';
import bingo_ball_3 from './public/images/bingo_ball_3.png';
import bingo_ball_4 from './public/images/bingo_ball_4.png';
import bingo_ball_5 from './public/images/bingo_ball_5.png';
import bingo_ball_6 from './public/images/bingo_ball_6.png';
import bingo_ball_7 from './public/images/bingo_ball_7.png';
import bingo_ball_8 from './public/images/bingo_ball_8.png';
import bingo_ball_9 from './public/images/bingo_ball_9.png';
import bingo_ball_10 from './public/images/bingo_ball_10.png';
import bingo_ball_11 from './public/images/bingo_ball_11.png';
import bingo_ball_12 from './public/images/bingo_ball_12.png';
import bingo_ball_13 from './public/images/bingo_ball_13.png';
import bingo_ball_14 from './public/images/bingo_ball_14.png';
import bingo_ball_15 from './public/images/bingo_ball_15.png';
import bingo_ball_16 from './public/images/bingo_ball_16.png';
import bingo_ball_17 from './public/images/bingo_ball_17.png';
import bingo_ball_18 from './public/images/bingo_ball_18.png';
import bingo_ball_19 from './public/images/bingo_ball_19.png';
import bingo_ball_20 from './public/images/bingo_ball_20.png';
import bingo_ball_21 from './public/images/bingo_ball_21.png';
import bingo_ball_22 from './public/images/bingo_ball_22.png';
import bingo_ball_23 from './public/images/bingo_ball_23.png';
import bingo_ball_24 from './public/images/bingo_ball_24.png';
import bingo_ball_25 from './public/images/bingo_ball_25.png';
import bingo_ball_26 from './public/images/bingo_ball_26.png';
import bingo_ball_27 from './public/images/bingo_ball_27.png';
import bingo_ball_28 from './public/images/bingo_ball_28.png';
import bingo_ball_29 from './public/images/bingo_ball_29.png';
import bingo_ball_30 from './public/images/bingo_ball_30.png';
import bingo_ball_31 from './public/images/bingo_ball_31.png';
import bingo_ball_32 from './public/images/bingo_ball_32.png';
import bingo_ball_33 from './public/images/bingo_ball_33.png';
import bingo_ball_34 from './public/images/bingo_ball_34.png';
import bingo_ball_35 from './public/images/bingo_ball_35.png';
import bingo_ball_36 from './public/images/bingo_ball_36.png';
import bingo_ball_37 from './public/images/bingo_ball_37.png';
import bingo_ball_38 from './public/images/bingo_ball_38.png';
import bingo_ball_39 from './public/images/bingo_ball_39.png';
import bingo_ball_40 from './public/images/bingo_ball_40.png';
import bingo_ball_41 from './public/images/bingo_ball_41.png';
import bingo_ball_42 from './public/images/bingo_ball_42.png';
import bingo_ball_43 from './public/images/bingo_ball_43.png';
import bingo_ball_44 from './public/images/bingo_ball_44.png';
import bingo_ball_45 from './public/images/bingo_ball_45.png';
import bingo_ball_46 from './public/images/bingo_ball_46.png';
import bingo_ball_47 from './public/images/bingo_ball_47.png';
import bingo_ball_48 from './public/images/bingo_ball_48.png';
import bingo_ball_49 from './public/images/bingo_ball_49.png';
import bingo_ball_50 from './public/images/bingo_ball_50.png';
import bingo_ball_51 from './public/images/bingo_ball_51.png';
import bingo_ball_52 from './public/images/bingo_ball_52.png';
import bingo_ball_53 from './public/images/bingo_ball_53.png';
import bingo_ball_54 from './public/images/bingo_ball_54.png';
import bingo_ball_55 from './public/images/bingo_ball_55.png';
import bingo_ball_56 from './public/images/bingo_ball_56.png';
import bingo_ball_57 from './public/images/bingo_ball_57.png';
import bingo_ball_58 from './public/images/bingo_ball_58.png';
import bingo_ball_59 from './public/images/bingo_ball_59.png';
import bingo_ball_60 from './public/images/bingo_ball_60.png';
import bingo_ball_61 from './public/images/bingo_ball_61.png';
import bingo_ball_62 from './public/images/bingo_ball_62.png';
import bingo_ball_63 from './public/images/bingo_ball_63.png';
import bingo_ball_64 from './public/images/bingo_ball_64.png';
import bingo_ball_65 from './public/images/bingo_ball_65.png';
import bingo_ball_66 from './public/images/bingo_ball_66.png';
import bingo_ball_67 from './public/images/bingo_ball_67.png';
import bingo_ball_68 from './public/images/bingo_ball_68.png';
import bingo_ball_69 from './public/images/bingo_ball_69.png';
import bingo_ball_70 from './public/images/bingo_ball_70.png';
import bingo_ball_71 from './public/images/bingo_ball_71.png';
import bingo_ball_72 from './public/images/bingo_ball_72.png';
import bingo_ball_73 from './public/images/bingo_ball_73.png';
import bingo_ball_74 from './public/images/bingo_ball_74.png';
import bingo_ball_75 from './public/images/bingo_ball_75.png';
import Logo from './public/images/logo.jpg';
import LogoApp from './public/images/logo_app.png';

const Images = {
    1: bingo_ball_1,
    2: bingo_ball_2,
    3: bingo_ball_3,
    4: bingo_ball_4,
    5: bingo_ball_5,
    6: bingo_ball_6,
    7: bingo_ball_7,
    8: bingo_ball_8,
    9: bingo_ball_9,
    10: bingo_ball_10,
    11: bingo_ball_11,
    12: bingo_ball_12,
    13: bingo_ball_13,
    14: bingo_ball_14,
    15: bingo_ball_15,
    16: bingo_ball_16,
    17: bingo_ball_17,
    18: bingo_ball_18,
    19: bingo_ball_19,
    20: bingo_ball_20,
    21: bingo_ball_21,
    22: bingo_ball_22,
    23: bingo_ball_23,
    24: bingo_ball_24,
    25: bingo_ball_25,
    26: bingo_ball_26,
    27: bingo_ball_27,
    28: bingo_ball_28,
    29: bingo_ball_29,
    30: bingo_ball_30,
    31: bingo_ball_31,
    32: bingo_ball_32,
    33: bingo_ball_33,
    34: bingo_ball_34,
    35: bingo_ball_35,
    36: bingo_ball_36,
    37: bingo_ball_37,
    38: bingo_ball_38,
    39: bingo_ball_39,
    40: bingo_ball_40,
    41: bingo_ball_41,
    42: bingo_ball_42,
    43: bingo_ball_43,
    44: bingo_ball_44,
    45: bingo_ball_45,
    46: bingo_ball_46,
    47: bingo_ball_47,
    48: bingo_ball_48,
    49: bingo_ball_49,
    50: bingo_ball_50,
    51: bingo_ball_51,
    52: bingo_ball_52,
    53: bingo_ball_53,
    54: bingo_ball_54,
    55: bingo_ball_55,
    56: bingo_ball_56,
    57: bingo_ball_57,
    58: bingo_ball_58,
    59: bingo_ball_59,
    60: bingo_ball_60,
    61: bingo_ball_61,
    62: bingo_ball_62,
    63: bingo_ball_63,
    64: bingo_ball_64,
    65: bingo_ball_65,
    66: bingo_ball_66,
    67: bingo_ball_67,
    68: bingo_ball_68,
    69: bingo_ball_69,
    70: bingo_ball_70,
    71: bingo_ball_71,
    72: bingo_ball_72,
    73: bingo_ball_73,
    74: bingo_ball_74,
    75: bingo_ball_75,
    99: LogoApp,
    100: Logo
};


export default Images;
